export const commentHeader = `/**
 * Generated by @proofkit/typegen package
 * https://proofkit.proof.sh/docs/typegen
 * DO NOT EDIT THIS FILE DIRECTLY. Changes may be overwritten
 */


`;

export const pragmaComment = `
// @generated
// prettier-ignore

`;

export const overrideCommentHeader = `
/**
* Put your custom overrides or transformations here.
* Changes to this file will NOT be overwritten.
*/
`;

export const varname = (name: string) => name.replace(/[^a-zA-Z0-9_]/g, "");

export const defaultEnvNames = {
  apiKey: "OTTO_API_KEY",
  ottoPort: "OTTO_PORT",
  username: "FM_USERNAME",
  password: "FM_PASSWORD",
  clarisIdUsername: "CLARIS_ID_USERNAME",
  clarisIdPassword: "CLARIS_ID_PASSWORD",
  server: "FM_SERVER",
  db: "FM_DATABASE",
  fmMcpBaseUrl: "FM_MCP_BASE_URL",
  fmMcpConnectedFileName: "FM_CONNECTED_FILE_NAME",
  fmMcpPersistentToken: "FM_MCP_PERSISTENT_TOKEN",
};

export const defaultFmMcpBaseUrl = "http://127.0.0.1:1365";
